import type { DropdownOption } from 'constants/_types/DropdownOptions';

const generateOptionsFormFlatList = (array: string[]): DropdownOption[] => {
  const noDuplicates = Array.from(new Set(array));
  return noDuplicates.map((value: string) => ({ value, label: value }));
};

export default generateOptionsFormFlatList;
